module.exports = __webpack_public_path__ + "img/B4.0c1144c6.png";